import { render, staticRenderFns } from "./OrderChatMessage.vue?vue&type=template&id=08b24506&"
import script from "./OrderChatMessage.vue?vue&type=script&lang=js&"
export * from "./OrderChatMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports